/**
 *  All api related to product groups
 */
import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchProductGroup(options) {
  const { id, code, type = 'byId', ...params } = options
  const url = type === 'byCode'
    ? `product_groups/by_code/${code}`
    : `product_groups/${id}`
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchProductGroup',
    () => source.cancel('fetchProductGroup: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: url,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      productGroup: data.productGroup
    }))
}

export function fetchProductGroupByCode(options) {
  const { code, ...params } = options
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchProductGroupByCode',
    () => source.cancel('fetchProductGroupByCode: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `product_groups/by_code/${code}`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      productGroup: data.productGroup
    }))
}

export function fetchProductGroupLineByCode(options) {
  const { code, page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchProductGroupLineByCode',
    () => source.cancel('fetchProductGroupLineByCode: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `product_groups/by_code/${code}/product_group_lines`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      productGroupLines: data.productGroupLines,
      pagination: data.productGroupLinesPagination,
      next: _.get(data, 'productGroupLinesPagination.nextPage') > page
        ? () => fetchProductGroupLineByCode({
          page: page + 1,
          ...others
        })
        : null,
      count: _.get(data, 'productGroupLinesPagination.totalCount')
    }))
}

export function fetchProductGroupLine(options) {
  const { id, page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchProductGroupLine',
    () => source.cancel('fetchProductGroupLine: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `product_groups/${id}/product_group_lines`,
      method: 'get',
      params,
      cancelToken: source.token
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      productGroupLines: data.productGroupLines,
      pagination: data.productGroupLinesPagination,
      next: _.get(data, 'productGroupLinesPagination.nextPage') > page
        ? () => fetchProductGroupLine({
          page: page + 1,
          ...others
        })
        : null,
      count: _.get(data, 'productGroupLinesPagination.totalCount')
    }))
}
